import React, { useEffect, useState } from "react";
import firebase from "../../../firebase";
import "./blogPost.scss";
import {
  Button,
  Card,
  Modal,
  Form,
  Alert,
  Container,
  Row,
  Col,
  Pagination,
  CardGroup,
} from "react-bootstrap";
import { NavLink } from "react-router-dom";

export const BlogHome = () => {
  // console.log("🚀 ~ file: BlogHome.js:17 ~ props:", props);
  const postsPerPage = 5; // Number of posts to show per page
  const [posts, setPosts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  // Fetch or set your blog posts data here
  useEffect(() => {
    const ref = firebase.collection("/blog");
    function getData() {
      ref.onSnapshot((data) => {
        const item = [];
        data.forEach((doc) => {
          item.push(doc.data());
        });
        // setPosts(item);
        setPosts(
          item.sort((a, b) => {
            return b.id - a.id;
          })
        );
      });
    }
    getData();
  }, []);
  // Calculate the index of the last post of the current page
  const indexOfLastPost = currentPage * postsPerPage;
  // Calculate the index of the first post of the current page
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  // Get the current posts to display on the current page
  const currentPosts = posts.slice(indexOfFirstPost, indexOfLastPost);

  // Change the current page
  const handlePageChange = (page) => setCurrentPage(page);

  const getPaginationItems1 = () => {
    const totalPages = Math.ceil(posts.length / postsPerPage);
    return Array.from({ length: totalPages }).map((_, index) => (
      <Pagination.Item
        linkStyle={10}
        key={index + 1}
        active={index + 1 === currentPage}
        onClick={() => handlePageChange(index + 1)}
      >
        {index + 1}
      </Pagination.Item>
    ));
  };
  const getPaginationItems = () => {
    const totalPages = Math.ceil(posts.length / postsPerPage);
    const pageNumbers = [];
    const maxPageNumbersToShow = 5; // Maximum page numbers to show excluding ellipsis

    if (totalPages <= maxPageNumbersToShow) {
      // If there are fewer or equal to maxPageNumbersToShow pages, show all page numbers
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(
          <Pagination.Item
            style={{ color: "white" }}
            key={i}
            active={i === currentPage}
            onClick={() => handlePageChange(i)}
          >
            {i}
          </Pagination.Item>
        );
      }
    } else {
      // If there are more than maxPageNumbersToShow pages, add ellipsis
      const middlePage = Math.floor(maxPageNumbersToShow / 2);
      if (currentPage <= middlePage) {
        // Show first few page numbers and add ellipsis at the end
        for (let i = 1; i <= maxPageNumbersToShow - 1; i++) {
          pageNumbers.push(
            <Pagination.Item
              style={{ color: "white" }}
              key={i}
              active={i === currentPage}
              onClick={() => handlePageChange(i)}
            >
              {i}
            </Pagination.Item>
          );
        }
        pageNumbers.push(
          <Pagination.Ellipsis
            style={{ color: "white" }}
            key="ellipsis-start"
          />
        );
        pageNumbers.push(
          <Pagination.Item
            style={{ color: "white" }}
            key={totalPages}
            active={totalPages === currentPage}
            onClick={() => handlePageChange(totalPages)}
          >
            {totalPages}
          </Pagination.Item>
        );
      } else if (
        currentPage > middlePage &&
        currentPage <= totalPages - middlePage
      ) {
        // Show ellipsis on both sides of the current page
        pageNumbers.push(
          <Pagination.Item
            key={1}
            style={{ color: "white" }}
            onClick={() => handlePageChange(1)}
          >
            1
          </Pagination.Item>
        );
        pageNumbers.push(
          <Pagination.Ellipsis
            style={{ color: "white" }}
            key="ellipsis-start"
          />
        );
        for (
          let i = currentPage - middlePage;
          i <= currentPage + middlePage;
          i++
        ) {
          pageNumbers.push(
            <Pagination.Item
              style={{ color: "white" }}
              key={i}
              active={i === currentPage}
              onClick={() => handlePageChange(i)}
            >
              {i}
            </Pagination.Item>
          );
        }
        pageNumbers.push(
          <Pagination.Ellipsis style={{ color: "white" }} key="ellipsis-end" />
        );
        pageNumbers.push(
          <Pagination.Item
            style={{ color: "white" }}
            key={totalPages}
            active={totalPages === currentPage}
            onClick={() => handlePageChange(totalPages)}
          >
            {totalPages}
          </Pagination.Item>
        );
      } else {
        // Show last few page numbers and add ellipsis at the start
        pageNumbers.push(
          <Pagination.Item
            style={{ color: "white" }}
            key={1}
            active={1 === currentPage}
            onClick={() => handlePageChange(1)}
          >
            1
          </Pagination.Item>
        );
        pageNumbers.push(
          <Pagination.Ellipsis style={{ color: "white" }} key="ellipsis-end" />
        );
        for (
          let i = totalPages - maxPageNumbersToShow + 2;
          i <= totalPages;
          i++
        ) {
          pageNumbers.push(
            <Pagination.Item
              style={{ color: "white" }}
              key={i}
              active={i === currentPage}
              onClick={() => handlePageChange(i)}
            >
              {i}
            </Pagination.Item>
          );
        }
      }
    }

    return pageNumbers;
  };

  const goToPreviousPage = () => {
    if (currentPage > 1) {
      handlePageChange(currentPage - 1);
    }
  };

  const goToNextPage = () => {
    const totalPages = Math.ceil(posts.length / postsPerPage);
    if (currentPage < totalPages) {
      handlePageChange(currentPage + 1);
    }
  };

  return (
    // style={{ marginTop: "10px" ,width: "50vw" }}
    <div className="blogCard">
      <Container>
        <h1 className="blogHeading">Social Media Marketing Tool</h1>
        <Row xs={1} md={2} className="g-5">
          {currentPosts.map((post) => {
            const { id, heading, blogImage, content, date, auther } = post;
            return (
              <Col key={id}>
                <CardGroup>
                  <NavLink
                    className="recentBlogNavLink"
                    key={id}
                    to={`/blog/${post.title}`}
                  >
                    <Card
                      style={{ margin: "5px" }}
                      text="dark"
                      className="blogs"
                    >
                      <Card.Img variant="top" src={blogImage} />
                      <Card.Body>
                        {/* <Card.Title text="dark" style={{}}>{heading}</Card.Title> */}
                        <Card.Text>{heading}</Card.Text>
                        <Card.Footer
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <small className="text-muted recentPostedOn">
                            {date}
                          </small>
                          <small className="text-muted recentPostedOn">
                            by : {auther}
                          </small>
                        </Card.Footer>
                      </Card.Body>
                    </Card>
                  </NavLink>
                </CardGroup>
              </Col>
            );
          })}
        </Row>
        <Row>
          <Col className="d-flex justify-content-center mt-3">
            {/* <Pagination size="sm">  */}
            {/* {Array.from({
                length: Math.ceil(posts.length / postsPerPage),
              }).map((_, index) => (
                <Pagination.Item
                  key={index + 1}
                  active={index + 1 === currentPage}
                  onClick={() => handlePageChange(index + 1)}
                >
                  {index + 1}
                </Pagination.Item>
              ))} */}
            {/* <Pagination.Prev onClick={goToPreviousPage} disabled={currentPage === 1} />
            {getPaginationItems()}
            <Pagination.Next onClick={goToNextPage} disabled={currentPage === Math.ceil(posts.length / postsPerPage)} />
            </Pagination> */}

            <Pagination size="sm">{getPaginationItems()}</Pagination>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
